import"../../../../../../@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as e}from"../../../../../../lit-html@3.2.1/node_modules/lit-html/lit-html.js";import"../../../../../../lit-element@4.1.1/node_modules/lit-element/lit-element.js";import{Progress as t}from"./progress.js";/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */class d extends t{renderIndicator(){return this.indeterminate?this.renderIndeterminateContainer():this.renderDeterminateContainer()}renderDeterminateContainer(){const r=(1-this.value/this.max)*100;return e`
      <svg viewBox="0 0 4800 4800">
        <circle class="track" pathLength="100"></circle>
        <circle
          class="active-track"
          pathLength="100"
          stroke-dashoffset=${r}></circle>
      </svg>
    `}renderIndeterminateContainer(){return e` <div class="spinner">
      <div class="left">
        <div class="circle"></div>
      </div>
      <div class="right">
        <div class="circle"></div>
      </div>
    </div>`}}export{d as CircularProgress};
